module.exports = __webpack_public_path__ + "img/image_1.522cac4d.jpg";